export const NAVBAR_CATEGORY_COLORS = {
  academic: '#5e94fe',
  'early-career': '#76ad47',
  edutainment: '#ff8000',
  'print-rich': '#ff0592',
  maker: '#a06ad9',
  'info-hub': '#07c9a6',
};

export const DEFAULT_NAVBAR_CATEGORY_COLOR = '#6d8fe3';
